import styled from "styled-components";

export const PageTitleStyled = styled.div`  
    display: flex;
    justify-content: space-between;
    margin-inline-end: 170px;
    margin-bottom: 20px;

    h1 {      
      font-style: normal;
      font-weight: 700;
      font-size: 30px;
      line-height: 34px;
      color: var(--bllink-gray);
      text-align: start;

      .building-address {
        color: var(--bllink-purple);
        margin-inline-start: 5px;
      }

      .subtitle {
        font-size: 20px;
        line-height: 23px;
        color: rgba(55, 54, 71, 0.7);
        margin-top: 12px;
      }
    }

    .icons-bar {
      margin-top 9px;
    }
`;
